import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { ProductSlug } from '../../../types';
import styles from './product-sub-menu.styles.scss';

import { localized } from '@lit/localize';
import { t } from '../../../services/runtime-i18n';
import '../../product-icon/product-icon';

export const PRODUCT_SUB_MENU_TAG = 'spog-common-menu-product-sub-menu' as const;

/**
 * Product's submenu item.
 */
@customElement(PRODUCT_SUB_MENU_TAG)
@localized()
export class SpogProductSubMenu extends LitElement {
  static override styles = [styles];
  @property()
  product!: string;

  @property()
  baseHref!: string;

  @property()
  productSlug!: ProductSlug;

  override render() {
    return html`
      <h2>
        <a href="${this.baseHref}">
          <platform-product-icon productSlug=${this.productSlug}></platform-product-icon>
          ${t(this.productSlug, this.product)}
        </a>
      </h2>
      <slot name="items"></slot>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [PRODUCT_SUB_MENU_TAG]: SpogProductSubMenu;
  }
}
